import RefContainer from "csi/heading/RefContainer";
import html from "csi/html";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

const AllSeasonsCPRenderer = declare(RefContainer, {

	/**
	 * @override
	 * In case of "All Seasons" Color Palette types, we need to render the static text "All Seasons"
	 * And in other cases such as Single Season or MultiSeason, then return the Seasons Names as Navigable links.
	 */
	toHtmlStatic(ctx, h, refNode, actionData) {
		const node = ctx.getNode();
		const seasons = node.Seasons;
		if (!seasons.length) {
			html.create("span", {
				innerText: locale.resource("AllSeasons"),
			}, refNode);
			return true;
		}
		return this.inherited(arguments);
	},
});

export = AllSeasonsCPRenderer;